import { render, staticRenderFns } from "./AccountDebugTab.vue?vue&type=template&id=0994c674&"
import script from "./AccountDebugTab.vue?vue&type=script&lang=js&"
export * from "./AccountDebugTab.vue?vue&type=script&lang=js&"
import style0 from "./AccountDebugTab.vue?vue&type=style&index=0&id=0994c674&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports